import { render } from "./WCSidebarMenuItemV2.vue?vue&type=template&id=b5bbb282&scoped=true"
import script from "./WCSidebarMenuItemV2.vue?vue&type=script&lang=js"
export * from "./WCSidebarMenuItemV2.vue?vue&type=script&lang=js"

import "./WCSidebarMenuItemV2.vue?vue&type=style&index=0&id=b5bbb282&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bbb282"]])

export default __exports__